// Central studio configuration - easily editable
import heroWorkstation from "@/assets/hero/hero-workstation.jpg";
import heroLounge from "@/assets/hero/hero-lounge.jpg";
import heroEntrance from "@/assets/hero/hero-entrance.jpg";
import heroHallway from "@/assets/hero/hero-hallway.jpg";
import heroWalkthrough1 from "@/assets/hero-video/hero-walkthrough-1.mp4";
import heroWalkthrough1Poster from "@/assets/hero-video/hero-walkthrough-1-poster.jpg";
import heroWalkthrough2 from "@/assets/hero-video/hero-walkthrough-2.mp4";
import heroWalkthrough2Poster from "@/assets/hero-video/hero-walkthrough-2-poster.jpg";
import tattooImage from "@/assets/services/Tattooocard.png";
import piercingImage from "@/assets/services/Piercingcard.png";
import manishImage from "@/assets/artists/manish.jpg";
import sanketImage from "@/assets/artists/sanket.jpg";
import tattooImageNew1 from "@/assets/work/tattoos/IMG-20260830-WA0050.jpg";
import tattooImageNew2 from "@/assets/work/tattoos/IMG-20260901-WA0032-1.jpg";
import tattooImageNew3 from "@/assets/work/tattoos/IMG-20260901-WA0019-1.jpg";
import tattooImageNew4 from "@/assets/work/tattoos/IMG-20260902-WA0072.jpg";
import tattooImage1 from "@/assets/work/tattoos/IMG-20260901-WA0003.jpg";
import tattooImage2 from "@/assets/work/tattoos/IMG-20260901-WA0004.jpg";
import tattooImage3 from "@/assets/work/tattoos/IMG-20260901-WA0005.jpg";
import tattooImage4 from "@/assets/work/tattoos/IMG-20260901-WA0006.jpg";
import tattooImage5 from "@/assets/work/tattoos/IMG-20260901-WA0007.jpg";
import tattooImage6 from "@/assets/work/tattoos/IMG-20260901-WA0008.jpg";
import tattooImage7 from "@/assets/work/tattoos/IMG-20260901-WA0009.jpg";
import tattooImage8 from "@/assets/work/tattoos/IMG-20260901-WA0010.jpg";
import tattooImage9 from "@/assets/work/tattoos/IMG-20260901-WA0011.jpg";
import tattooImage10 from "@/assets/work/tattoos/IMG-20260901-WA0012.jpg";
import tattooImage11 from "@/assets/work/tattoos/IMG-20260901-WA0013.jpg";
import tattooImage12 from "@/assets/work/tattoos/IMG-20260901-WA0014.jpg";
import tattooImage13 from "@/assets/work/tattoos/IMG-20260901-WA0015.jpg";
import tattooImage14 from "@/assets/work/tattoos/IMG-20260901-WA0016.jpg";
import tattooImage15 from "@/assets/work/tattoos/IMG-20260901-WA0017.jpg";
import tattooImage16 from "@/assets/work/tattoos/IMG-20260901-WA0019.jpg";
import tattooImage17 from "@/assets/work/tattoos/IMG-20260901-WA0020.jpg";
import tattooImage18 from "@/assets/work/tattoos/IMG-20260901-WA0021.jpg";
import tattooImage19 from "@/assets/work/tattoos/IMG-20260901-WA0022.jpg";
import tattooImage20 from "@/assets/work/tattoos/IMG-20260901-WA0023.jpg";
import tattooImage21 from "@/assets/work/tattoos/IMG-20260901-WA0024.jpg";
import tattooImage22 from "@/assets/work/tattoos/IMG-20260901-WA0025.jpg";
import tattooImage23 from "@/assets/work/tattoos/IMG-20260901-WA0026.jpg";
import tattooImage24 from "@/assets/work/tattoos/IMG-20260901-WA0027.jpg";
import tattooImage25 from "@/assets/work/tattoos/IMG-20260901-WA0028.jpg";
import tattooImage26 from "@/assets/work/tattoos/IMG-20260901-WA0029.jpg";
import tattooImage27 from "@/assets/work/tattoos/IMG-20260901-WA0030.jpg";
import tattooImage28 from "@/assets/work/tattoos/IMG-20260901-WA0031.jpg";
import tattooImage29 from "@/assets/work/tattoos/IMG-20260901-WA0032.jpg";
import tattooImage30 from "@/assets/work/tattoos/IMG-20260901-WA0033.jpg";
import tattooImage31 from "@/assets/work/tattoos/tatttooo.jpg";

import piercingImage1 from "@/assets/work/piercings/IMG-20260901-WA0018.jpg";
import piercingImage2 from "@/assets/work/piercings/IMG-20260901-WA0049.jpg";
import piercingImage3 from "@/assets/work/piercings/IMG-20260901-WA0051.jpg";
import piercingImage4 from "@/assets/work/piercings/IMG-20260901-WA0055.jpg";
import piercingImage5 from "@/assets/work/piercings/IMG-20260901-WA0059.jpg";
import piercingImage6 from "@/assets/work/piercings/IMG-20260901-WA0064.jpg";
import piercingImage7 from "@/assets/work/piercings/IMG-20260901-WA0066.jpg";
import piercingImage8 from "@/assets/work/piercings/IMG-20260901-WA0068.jpg";
import piercingImage9 from "@/assets/work/piercings/IMG-20260901-WA0070.jpg";
import piercingImage10 from "@/assets/work/piercings/IMG-20260901-WA0072.jpg";
import piercingImage11 from "@/assets/work/piercings/IMG-20260901-WA0074.jpg";
import piercingImage12 from "@/assets/work/piercings/IMG-20260901-WA0076.jpg";
import piercingImage13 from "@/assets/work/piercings/IMG-20260901-WA0078.jpg";
import piercingImage14 from "@/assets/work/piercings/IMG-20260901-WA0080.jpg";
import piercingImage15 from "@/assets/work/piercings/IMG-20260901-WA0082.jpg";


import manishPortfolio1 from "@/assets/artists/manish_portfolio/IMG-20260901-WA0010.jpg";
import manishPortfolio2 from "@/assets/artists/manish_portfolio/IMG-20260901-WA0019.jpg";
import manishPortfolio3 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0044.jpg";
import manishPortfolio4 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0046.jpg";
import manishPortfolio5 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0048.jpg";
import manishPortfolio6 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0050.jpg";
import manishPortfolio7 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0052.jpg";
import manishPortfolio8 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0055.jpg";
import manishPortfolio9 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0057.jpg";
import manishPortfolio10 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0059.jpg";
import manishPortfolio11 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0061.jpg";
import manishPortfolio12 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0063.jpg";
import manishPortfolio13 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0065.jpg";
import manishPortfolio14 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0068.jpg";
import manishPortfolio15 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0070.jpg";
import manishPortfolio16 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0071.jpg";
import manishPortfolio17 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0072.jpg";
import manishPortfolio18 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0073.jpg";
import manishPortfolio19 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0074.jpg";
import manishPortfolio20 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0075.jpg";
import manishPortfolio21 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0076.jpg";
import manishPortfolio22 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0077.jpg";
import manishPortfolio23 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0078.jpg";
import manishPortfolio24 from "@/assets/artists/manish_portfolio/IMG-20260902-WA0079.jpg";

import sanketPortfolio1 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0003.jpg";
import sanketPortfolio2 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0006.jpg";
import sanketPortfolio3 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0007.jpg";
import sanketPortfolio4 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0014.jpg";
import sanketPortfolio5 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0016.jpg";
import sanketPortfolio6 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0023.jpg";
import sanketPortfolio7 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0024.jpg";
import sanketPortfolio8 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0028.jpg";
import sanketPortfolio9 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0031.jpg";
import sanketPortfolio10 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0032.jpg";
import sanketPortfolio11 from "@/assets/artists/sanket_portfolio/IMG-20260901-WA0033.jpg";

export const STUDIO = {
  name: "VOW TATTOO",
  logo: "https://i.ibb.co/996zM6n/vow-logo.png",
  tagline: "Tattoo & Piercing Atelier",
  phone: "+91 8850185558",
  whatsapp: "918850185558", // digits only for wa.me link
  email: "vow.tattoos05@gmail.com",
  address: "Shop No 1, Shiv Megha, Ramdev Park Rd, opp. Rashmi Marriage Ground, Beverly Park, Mira Road East, Mumbai, Mira Bhayandar, Maharashtra 401105",
  instagram: "@vowtattoostudio",
  years: 5,
  clients: 500,
  artists: 2,
  rating: 5.0,
};

// Built from the business name + address so Google always resolves to the
// current, correct verified listing — rather than a numeric place ID that
// can go stale or point slightly off from the actual business premises.
const MAPS_QUERY = encodeURIComponent(`Vow Tattoo Studio, ${STUDIO.address}`);
STUDIO.mapEmbed = `https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`;
STUDIO.mapsUrl = `https://www.google.com/maps/search/?api=1&query=${MAPS_QUERY}`;
STUDIO.directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${MAPS_QUERY}`;

export const heroSlides = [
  {
    url: heroWorkstation,
    alt: "VOW Tattoo Studio artist workstation",
  },
  {
    url: heroLounge,
    alt: "VOW Tattoo Studio client lounge and waiting area",
  },
  {
    url: heroEntrance,
    alt: "VOW Tattoo Studio reception and entrance",
  },
  {
    url: heroHallway,
    alt: "VOW Tattoo Studio interior hallway",
  },
];

export const services = [
  {
    key: "tattoo",
    title: "Custom Tattoo Designing",
    description:
      "Hand-drawn, one-of-one compositions. Fine line, blackwork, neo-traditional and illustrative — crafted around your story.",
    image: tattooImage,
    points: ["Consultation", "Original Drawing", "Sterile Application"],
  },
  {
    key: "piercing",
    title: "Piercings",
    description:
      "Precision placement with implant-grade titanium jewelry. Every puncture performed in our sterile, medical-grade suite.",
    image: piercingImage,
    points: ["Sterile Suite", "Titanium Jewelry", "Aftercare Guidance"],
  },
];

export const galleryTattoo = [
  tattooImageNew1,
  tattooImageNew2,
  tattooImageNew3,
  tattooImageNew4,
  tattooImage5,
  tattooImage6,
  tattooImage8,
  tattooImage10,
  tattooImage12,
  tattooImage13,
  tattooImage14,
  tattooImage15,
  tattooImage16,
  tattooImage17,
  tattooImage18,
  tattooImage19,
  tattooImage20,
  tattooImage21,
  tattooImage22,
  tattooImage23,
  tattooImage24,
  tattooImage25,
  tattooImage26,
  tattooImage27,
  tattooImage28,
  tattooImage29,
  tattooImage30,
  tattooImage31,
];

export const galleryPiercing = [
  piercingImage1,
  piercingImage2,
  piercingImage3,
  piercingImage4,
  piercingImage5,
  piercingImage6,
  piercingImage8,
  piercingImage10,
  piercingImage12,
  piercingImage13,
  piercingImage14,
  piercingImage15,
];

export const galleryStudio = [
  { url: heroWorkstation, alt: "VOW Tattoo Studio artist workstation" },
  { url: heroLounge, alt: "VOW Tattoo Studio client lounge and waiting area" },
  { url: heroEntrance, alt: "VOW Tattoo Studio reception and entrance" },
  { url: heroHallway, alt: "VOW Tattoo Studio interior hallway" },
];

export const testimonials = [
  {
    name: "Sandhya",
    quote: "One of the best experiences for a tattoo! The hygiene here is impressive and the staff is incredibly welcoming. Definitely the top choice in Mira Road.",
    piece: "Custom Tattoo",
  },
  {
    name: "Akshay & Team",
    quote: "Superb artistic work. I was unable to finalize a design, but the team helped me create a custom piece specially for me. Highly recommended!",
    piece: "Customized Design",
  },
  {
    name: "Local Guide",
    quote: "VOW Studio stands out for its attention to detail. Skilled professionals specializing in everything from minimalist scripts to realism.",
    piece: "Realism Tattoo",
  },
  {
    name: "Verified Client",
    quote: "Consistent service quality and transparent pricing. It's rare to find such a sanctuary for self-care in the middle of Mira Bhayandar.",
    piece: "Fine Line Work",
  },
];

export const artists = [
  {
    slug: "manish-mondol",
    name: "Manish Mondol",
    specialty: "Tattoo and Piercing",
    image: manishImage,
    bio: "Manish Mondol is our senior artist with over 10 years of experience in piercing and tattooing. He believes every tattoo should be as unique as the person wearing it, which is why custom designs are at the heart of his work. From delicate fine line tattoos to detailed portraits, vibrant pieces as a color specialist, and bold large-scale pieces, his expertise speaks through every stroke. Precision, creativity, and passion—that’s what Manish brings to every piece he creates.",
    portfolio: [
      manishPortfolio1,
      manishPortfolio2,
      manishPortfolio3,
      manishPortfolio4,
      manishPortfolio5,
      manishPortfolio6,
      manishPortfolio7,
      manishPortfolio8,
      manishPortfolio9,
      manishPortfolio10,
      manishPortfolio11,
      manishPortfolio12,
      manishPortfolio13,
      manishPortfolio14,
      manishPortfolio15,
      manishPortfolio16,
      manishPortfolio17,
      manishPortfolio18,
      manishPortfolio19,
      manishPortfolio20,
      manishPortfolio21,
      manishPortfolio22,
      manishPortfolio23,
      manishPortfolio24,
    ],
  },
  {
    slug: "sanket-asvale",
    name: "Sanket Asvale",
    specialty: "Fine Line · Portraits · Cover-ups",
    image: sanketImage,
    bio: "Sanket Asvale is a talented artist with 3 years of experience in tattooing. He believes in creating designs that are personal and meaningful, with a strong focus on custom work that reflects your story. From clean fine line tattoos to detailed portraits and seamless cover-ups — Sanket brings precision and creativity to every piece. Subtle, skilled, and detail-driven — his work speaks for itself.",
    portfolio: [
      sanketPortfolio1,
      sanketPortfolio2,
      sanketPortfolio3,
      sanketPortfolio4,
      sanketPortfolio5,
      sanketPortfolio6,
      sanketPortfolio7,
      sanketPortfolio8,
      sanketPortfolio9,
      sanketPortfolio10,
      sanketPortfolio11,
    ],
  },
];
